import React, { useState, useRef } from "react"
import { collections } from "../../lib/prop-types"
import { Media } from "../../lib/media-queries"
import MobileHeader from "./mobile"
import DesktopHeader from "./desktop"
import SearchModalContext, {
  initialSearchState
} from "../search/searchModalContext"
import useSearchClient from "../../lib/hooks/useSearchClient"
import useViewedResults from "../../lib/hooks/useViewedResults"

const Header = ({ collection }) => {
  const localStorageExists = typeof localStorage !== "undefined"
  const [viewedResults, setViewedResults] = localStorageExists
    ? useViewedResults()
    : []
  const [openSearchModal, setOpenSearchModal] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [hits, setHits] = useState(initialSearchState)
  const resultsListRef = useRef(null)
  const client = useSearchClient()
  return (
    <SearchModalContext.Provider
      /* eslint-disable-next-line react/jsx-no-constructed-context-values */
      value={{
        openSearchModal,
        setOpenSearchModal,
        searchTerm,
        setSearchTerm,
        viewedResults,
        setViewedResults,
        hits,
        setHits,
        resultsListRef,
        client
      }}
    >
      <Media lessThan="lg">
        <MobileHeader collection={collection} />
      </Media>
      <Media greaterThanOrEqual="lg">
        <DesktopHeader collection={collection} />
      </Media>
    </SearchModalContext.Provider>
  )
}

Header.propTypes = {
  collection: collections.isRequired
}

export default Header
